<template>
  <v-data-table v-bind="$attrs" v-on="$listeners" :headers="headers" :items="patients" :value="selected">
    <template v-slot:item.soignant="{ item }"> {{ item.doctor.first_name }} {{ item.doctor.last_name }}</template>
    <template v-slot:item.stack="{ item }">
      <div>
        <div v-if="item.stacks && item.stacks[0]">
          <span v-if="item.stacks[0].completion === 0">Inscription en attente</span>
          <span v-if="item.stacks[0].completion === 1">Inscription validée</span>
          <span v-if="item.stacks[0].completion === 2">Questionnaires complétés</span>
          <v-progress-linear :value="(item.stacks[0].completion / 2) * 100" />
        </div>
      </div>
    </template>
    <template v-slot:item.alerts="{ item }">
      <div v-if="item.application_profile.patient_alerts">
        <span v-show="lastLevelIs(patient_alert(item.application_profile.patient_alerts), 'LEVEL_RED')" class="red--text"
          >Alerte Rouge
          <v-icon class="red--text">warning</v-icon>
        </span>
        <span v-show="lastLevelIs(patient_alert(item.application_profile.patient_alerts), 'LEVEL_ORANGE')" class="orange--text"
          >Alerte Orange
          <v-icon class="orange--text">warning</v-icon>
        </span>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("patientsN", ["selected"]),

    headers() {
      return [
        {
          text: "#",
          value: "id",
        },
        {
          text: "Nom",
          value: "last_name",
        },
        {
          text: "Prénom",
          value: "first_name",
        },
        {
          text: "Soignant",
          value: "soignant",
        },
        {
          text: "Parcours",
          value: "stack",
        },
        {
          text: "Alertes",
          value: "alerts",
        },
      ];
    },
  },

  methods: {
    latestStackIndex(stacks) {
      return stacks.length - 1;
    },

    setItemPerPage($event) {
      if ($event === "Tous") {
        $event = "All";
      }

      this.$emit("paginate", $event);
      if (this.patients && this.patients.data) {
        this.options["itemsPerPage"] = this.patients.data.length;
      }
    },

    patient_alert(alerts) {
      if (alerts.length) {
        return alerts.filter(function (alert) {
          return alert.seen_at === null;
        });
      }
      return alerts;
    },

    lastLevelIs(alerts, level) {
      if (alerts && alerts[alerts.length - 1]) {
        return alerts[alerts.length - 1].level === level;
      }
    },
  },

  props: {
    patients: {
      required: true,
      type: Array,
    },
  },
};
</script>
